// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__276t3","questions":"styles_questions__5RhKa","footer":"styles_footer__1U86n"};